/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import {
  Extraction,
  ExtractionFromJSON,
  ExtractionFromJSONTyped,
  ExtractionToJSON,
} from "./Extraction";

/**
 *
 * @export
 * @interface ExtractionListResponse
 */
export interface ExtractionListResponse {
  /**
   *
   * @type {number}
   * @memberof ExtractionListResponse
   */
  offset: number;
  /**
   *
   * @type {number}
   * @memberof ExtractionListResponse
   */
  limit: number;
  /**
   *
   * @type {string}
   * @memberof ExtractionListResponse
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof ExtractionListResponse
   */
  sort: string;
  /**
   *
   * @type {number}
   * @memberof ExtractionListResponse
   */
  count: number;
  /**
   *
   * @type {Array<Extraction>}
   * @memberof ExtractionListResponse
   */
  data: Array<Extraction>;
}

export function ExtractionListResponseFromJSON(
  json: any
): ExtractionListResponse {
  return ExtractionListResponseFromJSONTyped(json, false);
}

export function ExtractionListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExtractionListResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(ExtractionFromJSON),
  };
}

export function ExtractionListResponseToJSON(
  value?: ExtractionListResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(ExtractionToJSON),
  };
}
